import { render, staticRenderFns } from "./SampleSetsCompact.vue?vue&type=template&id=c28cb622&scoped=true&"
import script from "./SampleSetsCompact.vue?vue&type=script&lang=js&"
export * from "./SampleSetsCompact.vue?vue&type=script&lang=js&"
import style0 from "./SampleSetsCompact.vue?vue&type=style&index=0&id=c28cb622&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28cb622",
  null
  
)

export default component.exports